import React, { createContext, useContext, useState } from 'react';

interface LoaderContextProps {
  loading: boolean;
  setLoading: (value: boolean) => void;
}
const LoaderContext = createContext<LoaderContextProps | undefined>(undefined);

export const useLoader = () => {
  const context = useContext(LoaderContext);
  if (!context) {
    throw new Error('Not Loading');
  }
  return context;
};

export const LoaderProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [loading, setLoading] = useState(false);
  return <LoaderContext.Provider value={{ loading, setLoading }}>{children}</LoaderContext.Provider>;
};
